import { SubmitHandler, useForm } from "react-hook-form";
import { Channel, Platform, UserStudio } from '../../../../features/api/apiSlice';
import { ReactComponent as SendSVG } from "./assets/send.svg";
import styles from "./Form.module.css";
import { Message as IMessage } from "../../../../features/api/apiSlice";
import SelectedPlatform from "../../../SelectPlatform";
import { useContext } from "react";
import { SelectPlatformProps } from "../../../SelectPlatform/SelectPlatform.interface";
import { SelectedPlatformsContext } from "../../../SelectPlatform/SelectedPlatformsContext";

const availablePlatforms: SelectPlatformProps[] = [
  { id: 1, icon: 'vk', platform: "vk", name: "VK" },
  { id: 2, icon: 'twitch', platform: "twitch", name: "Twitch" },
  { id: 3, icon: 'trovo', platform: "trovo", name: "Trovo" },
  { id: 4, icon: 'youtube', platform: "youtube", name: "Youtube" },
  { id: 5, icon: 'gg', platform: "gg", name: "GoodGame" },
  { id: 6, icon: 'kick', platform: "kick", name: "Kick" },
  { id: 7, icon: 'telegram', platform: "telegram", name: "Telegram" },
  { id: 8, icon: 'vk_video_live', platform: "vk_video_live", name: "VK Видео Live" },
];

interface FormValues {
  message: string;
  platform: Platform;
}

interface Props {
  isDisabled: boolean;
  onSubmit: (message: IMessage) => void;
  children: React.ReactNode;
  channels?: Channel[];
  studioTemplates?: UserStudio;
}

const Form: React.FC<Props> = ({ onSubmit, children, isDisabled, channels, studioTemplates }) => {
  const { register, handleSubmit, reset, setFocus } = useForm<FormValues>();

  const filteredPlatforms = availablePlatforms.filter(platform => {
    if (studioTemplates?.broadcast.restream_templates.length) {
      return studioTemplates?.broadcast.restream_templates.some(
        template => template.enabled && template.platform === platform.platform
      );
    }
    return channels?.some(
      channel => channel.enabled && channel.platform === platform.platform
    );
  });

  const { selectedPlatformsName, setSelectedPlatformsName } = useContext(SelectedPlatformsContext);

  const handleSendMessage: SubmitHandler<FormValues> = ({ message, platform }) => {
    if(isDisabled || !message.trim()) return;

    onSubmit({
      message,
      user: 'Testing Assignee',
      platform,
      target_platform: selectedPlatformsName,
      date: Date.now()
    });

    setFocus("message");
    reset();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSubmit(handleSendMessage)();
      event.preventDefault();
    }
  };

  return (
    <form
      className={styles.form}
      onSubmit={handleSubmit(handleSendMessage)}
    >
      <input
        className={styles.form__input}
        type="text"
        autoComplete="off"
        placeholder="Введите сообщение"
        {...register("message", {
          required: "Content is required!",
        })}
        onKeyDown={handleKeyDown}
      />
      <div className={styles["form__platform-container"]}>
        <SelectedPlatform
          setTargetPlatform={setSelectedPlatformsName!}
          value={selectedPlatformsName!}
          availablePlatforms={filteredPlatforms}
        />
        <button
          type="submit"
          className={styles.form__submit}
        // disabled={false}
        >
          <SendSVG />
        </button>

        <div className={styles['form__action-scroll']}>
          {children}
        </div>
      </div>
    </form>
  );
};

export default Form;
